module.exports = __webpack_public_path__ + "img/取消收货.5fac659f.svg";